import React from 'react';

import { GalleryBlock } from '@/app/_components/GalleryBlock';
import { GalleryBlockProps } from './types';

import classes from './index.module.scss';

export const GalleryBlockGraphQL: React.FC<GalleryBlockProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <GalleryBlock galleryBlock={props} />
    </div>
  );
};

export default GalleryBlockGraphQL;
